export * from 'depreciations/actions/depreciations_actions';



// WEBPACK FOOTER //
// src/modules/secured/modules/depreciations/actions/index.js